import vmClient from 'app/services/vmClient';

import { Lesson } from 'app/constants/schemas/Lesson';
import { LessonHeader } from 'app/constants/schemas/LessonHeader';
import { User } from 'app/constants/schemas/User';
import { UserExternalAuth } from 'app/constants/schemas/UserExternalAuth';
import { UserProfile } from 'app/constants/schemas/UserProfile';
import { UserDetail } from 'app/constants/schemas/UserDetail';

// All types should be imported and exported from this file, to ensure they are included
// in the bundle file.

export { Ability } from 'app/constants/enums/Ability';
export { Answer } from 'app/constants/schemas/Answer';
export { ArticleSection } from 'app/constants/schemas/ArticleSection';
export { AuthProvider } from 'app/constants/enums/AuthProvider';
export { Banner } from 'app/constants/schemas/Banner';
export { BannerContext } from 'app/constants/schemas/BannerContext';
export { BannerImage } from 'app/constants/schemas/BannerImage';
export { BannerProduct } from 'app/constants/schemas/BannerProduct';
export { BannerTranslation } from 'app/constants/schemas/BannerTranslation';
export { BlockedEmailDomain } from 'app/constants/schemas/BlockedEmailDomain';
export { Brand } from 'app/constants/schemas/Brand';
export { BrandReference } from 'app/constants/schemas/BrandReference';
export { BrandDomain } from 'app/constants/schemas/BrandDomain';
export { BrandExternalSite } from 'app/constants/schemas/BrandExternalSite';
export { BrandSiteFeature } from 'app/constants/schemas/SiteFeatures/BrandSiteFeature';
export { Bibliography } from 'app/constants/schemas/Bibliography';
export { BibliographyType } from 'app/constants/enums/BibliographyType';
export { BotBooking } from 'app/constants/schemas/BotBooking';
export { BrandLogo } from 'app/constants/schemas/BrandLogo';
export { Category } from 'app/constants/schemas/Category';
export { CategoryCourses } from 'app/constants/schemas/CategoryCourses';
export { Cause } from 'app/constants/schemas/Cause';
export { CombinedLessonBooking } from 'app/constants/schemas/CombinedLessonBooking';
export { CommonText } from 'app/constants/schemas/CommonText';
export { Configuration } from 'app/constants/schemas/SiteFeatures/Configuration';
export { CopyrightLicense } from 'app/constants/enums/CopyrightLicense';
export { Course } from 'app/constants/schemas/Course';
export { CourseLessonHeaders } from 'app/constants/schemas/CourseLessonHeaders';
export { Curriculum } from 'app/constants/schemas/Curriculum';
export { CurriculumCategories } from 'app/constants/schemas/CurriculumCategories';
export { DeployInfo } from 'app/constants/schemas/DeployInfo';
export { DialogEntry } from 'app/constants/schemas/DialogEntry';
export { DialogSection } from 'app/constants/schemas/DialogSection';
export { DialogSentence } from 'app/constants/schemas/DialogSentence';
export { DialogSentenceQuiz } from 'app/constants/schemas/DialogSentenceQuiz';
export { DialogSpeaker } from 'app/constants/schemas/DialogSpeaker';
export { Duration, DurationMarshaller } from 'app/constants/schemas/Duration';
export { DictionaryTag } from 'app/constants/enums/DictionaryTag';
export { Error } from 'app/constants/schemas/Error';
export { Exercise } from 'app/constants/schemas/Exercise';
export { Image } from 'app/constants/schemas/Image';
export { InflectionType } from 'app/constants/enums/InflectionType';
export { IntegerRange } from 'app/constants/schemas/IntegerRange';
export { InternalTag } from 'app/constants/schemas/InternalTag';
export { Issue } from 'app/constants/schemas/Issue';
export { IssueReport } from 'app/constants/schemas/IssueReport';
export { RecordizedJoinResult } from 'app/constants/schemas/rtc/JoinResult';
export { Language } from 'app/constants/enums/Language';
export { LanguageProficiencies } from 'app/constants/schemas/LanguageProficiencies';
export { Lesson };
export { LessonBibliography } from 'app/constants/schemas/LessonBibliography';
export { LessonBooking } from 'app/constants/schemas/LessonBooking';
export { LessonHeader };
export { LessonSentence, Translations } from 'app/constants/schemas/LessonSentence';
export { LessonStudent } from 'app/constants/schemas/LessonStudent';
export { LessonTeacher } from 'app/constants/schemas/LessonTeacher';
export { LicensePartner } from 'app/constants/enums/LicensePartner';
export { LocalBibliography } from 'app/constants/schemas/LocalBibliography';
export { LocalSentence } from 'app/constants/schemas/LocalSentence';
export { LocalWord } from 'app/constants/schemas/LocalWord';
export { Map } from 'app/constants/schemas/Map';
export { MediaEntry } from 'app/constants/schemas/MediaEntry';
export { MediaGroup } from 'app/constants/schemas/MediaGroup';
export { MediaSection } from 'app/constants/schemas/MediaSection';
export { MeetingBooking } from 'app/constants/schemas/MeetingBooking';
export { MeetingsConfig } from 'app/constants/schemas/SiteFeatures/MeetingsConfig';
export { OauthApplication } from 'app/constants/schemas/OauthApplication';
export { Offset } from 'app/constants/schemas/Offset';
export { Organization } from 'app/constants/schemas/Organization';
export { OrganizationDetails } from 'app/constants/schemas/OrganizationDetails';
export { OrganizationReference } from 'app/constants/schemas/OrganizationReference';
export { OrganizationSiteFeature } from 'app/constants/schemas/SiteFeatures/OrganizationSiteFeature';
export { Paragraph } from 'app/constants/schemas/Paragraph';
export { ParagraphSentence } from 'app/constants/schemas/ParagraphSentence';
export { ParagraphSentenceQuiz } from 'app/constants/schemas/ParagraphSentenceQuiz';
export { Participant } from 'app/constants/schemas/rtc/Participant';
export { Pdf } from 'app/constants/schemas/Pdf';
export { PdfSection } from 'app/constants/schemas/PdfSection';
export { PdfTranslation } from 'app/constants/schemas/PdfTranslation';
export { Period, BoundedPeriod } from 'app/constants/schemas/Period';
export { PersistenceRequest } from 'app/constants/schemas/rtc/PersistenceRequest';
export { Point } from 'app/constants/schemas/Point';
export { Question } from 'app/constants/schemas/Question';
export { QuestionSection } from 'app/constants/schemas/QuestionSection';
export { Room } from 'app/constants/schemas/rtc/Room';
export { Section } from 'app/constants/schemas/Section';
export { Sentence } from 'app/constants/schemas/Sentence';
export { SentenceTranslation } from 'app/constants/schemas/SentenceTranslation';
export { Server } from 'app/constants/schemas/rtc/Server';
export { ServiceDomain } from 'app/constants/schemas/ServiceDomain';
export { SiteFeature } from 'app/constants/enums/SiteFeature';
export { Sound } from 'app/constants/schemas/Sound';
export { StaffMember } from 'app/constants/schemas/StaffMember';
export { StaffPosition } from 'app/constants/enums/StaffPosition';
export { StaffProfile } from 'app/constants/schemas/StaffProfile';
export { StaffTeam } from 'app/constants/enums/StaffTeam';
export { Tag } from 'app/constants/schemas/Tag';
export { Teacher } from 'app/constants/schemas/Teacher';
export { TeacherApplication } from 'app/constants/schemas/TeacherApplication';
export { TeacherApplicationVideo } from 'app/constants/schemas/TeacherApplicationVideo';
export { TeacherProfile } from 'app/constants/schemas/TeacherProfile';
export { TeachingSkill } from 'app/constants/schemas/TeachingSkill';
export { TeachingSkills } from 'app/constants/schemas/TeachingSkills';
export { Text } from 'app/constants/schemas/Text';
export { TextTranslation } from 'app/constants/schemas/TextTranslation';
export { User };
export { UserDetail };
export { UserExternalAuth };
export { UserProfile };
export { UsersConfig } from 'app/constants/schemas/SiteFeatures/UsersConfig';
export { VocabList } from 'app/constants/schemas/VocabList';
export { VocabListHeader } from 'app/constants/schemas/VocabListHeader';
export { VocabListSentence } from 'app/constants/schemas/VocabListSentence';
export { VocabListWord } from 'app/constants/schemas/VocabListWord';
export { VocabListWordSentence } from 'app/constants/schemas/VocabListWordSentence';
export { VocabSection } from 'app/constants/schemas/VocabSection';
export { VocabSectionWord } from 'app/constants/schemas/VocabSectionWord';
export { VocabSectionWordSentence } from 'app/constants/schemas/VocabSectionWordSentence';
export { Word } from 'app/constants/schemas/Word';
export { WordForm } from 'app/constants/schemas/WordForm';
export { WordSentence } from 'app/constants/schemas/WordSentence';
export { WordSentenceOffsets } from 'app/constants/schemas/WordSentenceOffsets';
export { WordSentences } from 'app/constants/schemas/WordSentences';
export { WordTranslation } from 'app/constants/schemas/WordTranslation';
export { WordUsageAnswer } from 'app/constants/schemas/WordUsageAnswer';
export { WordUsageQuestion } from 'app/constants/schemas/WordUsageQuestion';

// Create union types of view models that are derived from the same dataset.
vmClient.bindRelatedTypes([Lesson, LessonHeader]);
vmClient.bindRelatedTypes([User, UserProfile, UserDetail]);
